module.exports = __webpack_public_path__ + "16d6d093a67250e3be6466e3ea03fc3c.svg";